import "./index.scss";

interface ButtonGroupProps {
  textConfirm: string;
  textCancel: string;
  onClick: any;
  disabled?: boolean;
}

export default function ButtonGroup({ textConfirm, textCancel, onClick, disabled }: ButtonGroupProps) {
  return (
    <div className="form-button">
      <button type="button" className="btn" onClick={onClick}>
        {!disabled ? textCancel : "Voltar"}
      </button>
      {!disabled && (
        <button type="submit" className="btn">
          {textConfirm}
        </button>
      )}
    </div>
  );
}
